export const en = {
  activities: {
    book_appointment: "Book appointment",
    book_medical_referral_meeting: "Book medical referral meeting",
    exercise_1: "Sit-to-stand",
    exercise_10: "Hip rotation",
    exercise_11: "Leg kick",
    exercise_12: "Leg lift on back",
    exercise_13: "Leg lift on side",
    exercise_14: "Leg lift on stomach",
    exercise_15: "Lunges",
    exercise_16: "Standing leg curl",
    exercise_17: "Twisted leg lift",
    exercise_18: "Bridge",
    exercise_19: "Bird dog",
    exercise_2: "Stepping",
    exercise_20: "Lying core strengthener",
    exercise_21: "Sitting core strengthener",
    exercise_22: "Lying knee raise",
    exercise_23: "Side plank",
    exercise_24: "Plank",
    exercise_25: "Push-ups",
    exercise_26: "Finger dance",
    exercise_27: "Bend and flex",
    exercise_28: "Grip strengthener",
    exercise_29: "Stretch and lift",
    exercise_3: "Hip strengthening",
    exercise_30: "Wrist stabilizer",
    exercise_31: "Finger lift",
    exercise_32: "Opening grip",
    exercise_33: "Standing row",
    exercise_34: "Standing core strengthener",
    exercise_35: "Foreward arm raise",
    exercise_36: "Shoulder retraction",
    exercise_37: "Diagonal arm raise",
    exercise_38: "Side-lying rotation",
    exercise_39: "Serratus press",
    exercise_4: "Weight transfer",
    exercise_40: "Shoulder stretch",
    exercise_41: "Standing external rotation",
    exercise_42: "Relaxation",
    exercise_43: "Neck stretch ",
    exercise_44: "Chin tuck",
    exercise_45: "Neck stabilizer",
    exercise_46: "Lateral arm raises",
    exercise_47: "Neck strengthener",
    exercise_48: "Presses",
    exercise_49: "Shrugs",
    exercise_5: "Single leg balance",
    exercise_50: "Overhead press",
    exercise_51: "Thumb strengthener",
    exercise_52: "Single leg deadlift",
    exercise_53: "Side-lying clam",
    exercise_54: "Reverse fly",
    exercise_55: "Squat jacks",
    exercise_56: "Bicycle crunch",
    exercise_57: "Lying toe taps",
    exercise_58: "Swimmer",
    exercise_59: "Mountain climbers",
    exercise_6: "Lying prone",
    exercise_60: "Single leg heel raise",
    exercise_61: "Lying back twist",
    exercise_7: "Knee-to-chest",
    exercise_8: "Butterfly",
    exercise_9: "Crossed legs",
    exercise_success: "Great job on this one!",
    finish_form_1: "Follow-up questionnaire",
    followup_health_report: "Follow-up questionnaire",
    functionality_1: "Measure your physical function",
    goal_1: "What happens next?",
    guide_1: "Joint Academy introduction",
    health_care_professional_intro_1: "Your specialist",
    health_report_1: "Your health",
    introduction: "Introduction",
    lesson_1: "What is osteoarthritis?",
    lesson_10: "Stepping",
    lesson_11: "Weight Transfer",
    lesson_12: "Hip-Strengthening",
    lesson_2: "How do you know you have osteoarthritis?",
    lesson_3: "How is osteoarthritis treated?",
    lesson_4: "How to handle pain and other common symptoms",
    lesson_5: "Osteoarthritis and activities",
    lesson_6: "The importance of lifestyle",
    lesson_8: "Exercising with osteoarthritis",
    lesson_9: "Sit-to-Stand",
    meet_your_pt: "Meet your physical therapist",
    part: "Part {number}",
    patient_claim_1: "Patient fee",
    payment_1: "Your Sustain subscription",
    report_1: "Weekly report",
    report_extended_1: "Weekly report",
    self_care_activation: "Time to continue on your own",
    subscription_1: "Coverage",
    sustain_intro_1: "Welcome to the Sustain Program!",
    text_lesson_1: "About Osteoarthritis",
    text_lesson_10: "About Motivation",
    text_lesson_11: "Weight Management",
    text_lesson_12: "The Importance of Sleep",
    text_lesson_13: "Strength & Cardio Exercise",
    text_lesson_14: "Healthy Eating",
    text_lesson_15: "Osteoarthritis & Work",
    text_lesson_17: "Joint Replacement Surgery",
    text_lesson_19: "Research on Healthy Eating",
    text_lesson_2: "Risk Factors for Osteoarthritis",
    text_lesson_20: "More About Surgery",
    text_lesson_21: "Strength, Mobility & Cardio",
    text_lesson_22: "Traveling with Osteoarthritis",
    text_lesson_23: "Exercising Before Surgery",
    text_lesson_24: "Managing Setbacks",
    text_lesson_25: "Dietary Supplements & Over-The-Counter Drugs",
    text_lesson_26: "Let Your Dog Help You",
    text_lesson_27: "Making Exercise More Fun",
    text_lesson_28: "Weight-Loss Progress",
    text_lesson_3: "Managing Your Symptoms",
    text_lesson_4: "Finding Your Diagnosis",
    text_lesson_5: "Exercise & Body Weight",
    text_lesson_6: "Managing Your Pain",
    text_lesson_7: "Exercise & Health",
    text_lesson_8: "Noninvasive Treatments",
    text_lesson_9: "Invasive Treatments",
    text_lesson_lbp01: "About Low Back Pain",
    text_lesson_lbp02: "Getting a Diagnosis",
    text_lesson_lbp03: "Anatomy of the Back",
    text_lesson_lbp04: "Common Causes of Back Pain",
    text_lesson_lbp05: "Less Common Causes of Back Pain",
    text_lesson_lbp06: "About Pain",
    text_lesson_lbp07: "Pain Management",
    text_lesson_lbp08: "Fear of Movement",
    text_lesson_lbp09: "Ergonomics",
    text_lesson_lbp10: "Physical Activity & Back Pain",
    text_lesson_lbp11: "Exercise & Back Pain",
    text_lesson_lbp12: "Other Treatment Options",
    text_lesson_lbp13: "About Low Back Surgery",
    text_lesson_lbp14: "Myths & Facts",
    text_lesson_lbp15: "Sleep & Pain",
    update_payment_method_1: "Upgrade your plan",
    w1_health_report: "Your health",
    weekly_health_report: "Weekly health report",
    payment_details: "Payment details",
  },
  buttons: {
    add: "Add",
    create_referral: "Create Referral",
    add_new_goal: "Add new goal",
    add_record: "Add record",
    cancel: "Cancel",
    change: "Change",
    change_language: "Change language to Swedish",
    confirm: "Confirm",
    confirm_sign: "Yes, sign",
    create: "Create",
    create_password: "Save new password",
    delete: "Delete",
    delete_goal: "Delete all goals",
    edit: "Edit",
    edit_goal: "Edit goals",
    invite: "Invite",
    no: "No",
    off: "Off",
    ok: "OK",
    on: "On",
    save: "Save",
    resend: "Resend",
    reset: "Reset",
    search: "Search",
    send_invitation: "Send invitation",
    sign_in_with_google: "Sign in with Google",
    sign_in: "Sign in",
    update: "Update",
    upload: "Upload",
    yes: "Yes",
    yes_sign: "Yes, sign",
    remove: "Remove",
    previous: "Previous",
    next: "Next",
    finish_review: "Finish Review",
    skip_to_summary: "Skip to Summary",
    back_to_review: "Back to Review",
    submit_all: "Submit & Invite ({{count}})",
    upload_more: "Upload More",
    done: "Done",
    actions: "Actions",
  },
  care_event_configurations: {
    configuration: "Configuration",
    id: "Id",
    label: "Care event configurations",
    name: "Name",
    other: "Other",
    payer: "Payer",
    tables: {
      no_configs_found: "No configurations found",
    },
    weekly_config: "Weekly configuration",
  },
  change_therapist: {
    remove_substitute: "Remove sub",
  },
  common: {
    compare_to_original: "Compare to original",
    created_at: "Created at",
    dos: "DOS",
    expires: "Expires",
    modified: "Modified",
    original: "Original",
    signed: "Signed",
  },
  create_plan_of_care: {
    box_button: "Create plan of care",
  },
  create_exercise: {
    title: "Create Exercise",
    success_message: "Exercise created successfully with ID: {{exerciseId}}",
    error_message: "Failed to create exercise",
  },
  view_exercise: {
    previous: "Previous",
    next: "Next",
    id_label: "ID: {{exerciseId}}",
    loading: "Loading...",
    error_loading: "Error loading exercise",
    sets: "{{sets}} sets",
  },
  edit_exercise: {
    title: "Edit Exercise",
    previous: "Previous",
    next: "Next",
    id_label: "ID: {{exerciseId}}",
    unsaved_changes_warning: "You have unsaved changes. Are you sure you want to navigate away?",
    delete_error: "Failed to delete exercise: {{error}}",
    enter_id_prompt: "Please enter id of exercise you want to edit",
    exercise_id_label: "Exercise ID",
    edit_button: "Edit Exercise with id: {{inputId}}",
    update_success: "Exercise {{id}} updated successfully",
    update_error: "Failed to update exercise: {{error}}",
    view_button: "View Exercise",
    delete_button: "Delete Exercise",
  },
  exercises: {
    title: "Exercises",
    filters: "Filters",
    clear_filters: "Clear Filters",
    joints: "Joints",
    positions: "Positions",
    movements: "Movements",
    equipments: "Equipment",
    state_label: "State",
    n_a: "N/A",
    locale: {
      sv_se: "Swedish (Sweden)",
      en_se: "English (Sweden)",
      en_gb: "English (UK)",
      en_us: "English (US)",
      es_us: "Spanish (US)",
    },
    search_label: "Search exercises...",
    search_placeholder: "Search by exercise name",
    filter_by_joints: "Filter by joints",
    filter_by_position: "Filter by position",
    filter_by_movement: "Filter by movement",
    filter_by_equipment: "Filter by equipment",
    filter_by_state: "Filter by state",
    view_label: "View",
    error_loading: "Error loading exercises",
    selected_ids: "Selected exercise IDs: {{ids}}",
    change_state_to: "Change state to:",
    change_position_to: "Change position to:",
    change_movement_to: "Change movement to:",
    no_exercises_found: 'No exercises found matching "{{searchTerm}}"',
    position: {
      none: "None",
      standing: "Standing",
      sitting: "Sitting",
      lying: "Lying",
    },
    movement: {
      none: "None",
      flexion: "Flexion",
      extension: "Extension",
      adduction: "Adduction",
      abduction: "Abduction",
      internal_rotation: "Internal Rotation",
      external_rotation: "External Rotation",
      lateral_flexion: "Lateral Flexion",
    },
    state: {
      all: "All",
      draft: "Draft",
      in_review: "In review",
      approved: "Approved",
      rejected: "Rejected",
    },
    view: {
      cards: "Cards",
      table: "Table",
    },
    button: {
      view: "View",
      edit: "Edit",
      delete: "Delete",
    },
    table: {
      exercise_id: "Exercise ID",
      title: "Title",
      about: "About",
      image: "Image",
      position: "Position",
      movement: "Movement",
      state: "State",
      target_joints: "Target Joints",
      updated_at: "Updated At",
      select: "Select",
      actions: "Actions",
    },
  },
  dashboard: {
    tables: {
      no_patients_found: "No patients found",
      no_therapists_found: "No therapists found",
      no_hcps_found: "No HCPs found",
      no_hcos_found: "No HCOs found",
      notes: {
        types: {
          PROTOCOL_DISCHARGE: "Discharge note",
          PROTOCOL_MONTHLY: "Monthly note",
          PROTOCOL_QUARTERLY: "Quarterly follow-up call",
          PROTOCOL_WEEKLY: "Treatment note { week_number }",
          PROTOCOL_WEEKLY_W0: "Kick-off call",
          PROTOCOL_WEEKLY_W1: "Treatment note",
          PROTOCOL_WEEKLY_W10: "Treatment note 9",
          PROTOCOL_WEEKLY_W11: "Treatment note 10",
          PROTOCOL_WEEKLY_W11_AND_W12: "Treatment note 10-11",
          PROTOCOL_WEEKLY_W12: "Treatment note 11",
          PROTOCOL_WEEKLY_W13: "Treatment note 12",
          PROTOCOL_WEEKLY_W14: "Treatment note 13",
          PROTOCOL_WEEKLY_W15: "Treatment note 14",
          PROTOCOL_WEEKLY_W16: "Treatment note 15",
          PROTOCOL_WEEKLY_W17: "Treatment note 16",
          PROTOCOL_WEEKLY_W18: "Treatment note 17",
          PROTOCOL_WEEKLY_W19: "Treatment note 18",
          PROTOCOL_WEEKLY_W2: "Treatment note 1",
          PROTOCOL_WEEKLY_W20: "Treatment note 19",
          PROTOCOL_WEEKLY_W3: "Treatment note 2",
          PROTOCOL_WEEKLY_W4: "Treatment note 3",
          PROTOCOL_WEEKLY_W5: "Treatment note 4",
          PROTOCOL_WEEKLY_W6: "Follow-up call",
          PROTOCOL_WEEKLY_W7: "Treatment note 6",
          PROTOCOL_WEEKLY_W7_AND_W8: "Treatment note 6-7",
          PROTOCOL_WEEKLY_W8: "Treatment note 7",
          PROTOCOL_WEEKLY_W9: "Treatment note 8",
          PROTOCOL_WEEKLY_W9_AND_W10: "Treatment note 8-9",
        },
      },
    },
  },
  dropdown: {
    logout: "Sign out",
  },
  errors: {
    claim_is_badly_formatted: "Claim is badly formatted",
    could_not_assign_substitute_therapist: "Could not assign substitute therapist",
    could_not_change_available_to_substitute: "Could not change available to substitute",
    could_not_change_hcp: "Could not update Health Care Provider",
    could_not_change_patient_inflow: "Could not change patient inflow",
    could_not_change_video_call_preferences: "Could not change video call preferences",
    could_not_close_account: "Could not close account",
    could_not_create_health_care_organization: "Could not create health care organization",
    could_not_create_record: "Could not create record",
    could_not_create_referral_source: "Could not create referral source",
    could_not_delete_document: "Could not delete document",
    could_not_delete_record: "Could not delete record",
    could_not_register_time_off: "Could not register time off",
    could_not_remove_offline_visit_and_billing: "Could not remove offline visit and billing",
    could_not_reopen_account: "Could not reopen account",
    could_not_reopen_treatment: "Could not reopen treatment",
    could_not_resubmit_claim: "Could not resubmit claim",
    could_not_send_invite: "Could not send invite",
    could_not_sign_in: "Could not sign in",
    could_not_update_activity: "Could not update activity",
    could_not_remove_activity: "Could not remove activity",
    could_not_update_health_care_organization: "Could not update health care organization",
    could_not_create_stripe_subscription: "Could not create Stripe subscription",
    could_not_update_stripe_subscription: "Could not update Stripe subscription",
    could_not_cancel_stripe_subscription: "Could not cancel Stripe subscription",
    could_not_update_hcp: "Could not update health care provider",
    could_not_update_personal_information: "Could not update personal information",
    could_not_update_record: "Could not update record",
    could_not_update_roles: "Could not update roles",
    could_not_update_therapist_type: "Could not update therapist type",
    could_not_update_state_licences: "Could not update state licences",
    could_not_upload_abn: "Could not upload ABN document",
    could_not_upload_poc: "Could not upload plan of care",
    could_not_upload_referral: "Could not upload referral",
    generic: "Something went wrong. Try again.",
    generic_login: "Something went wrong. Please try again later.",
    generic_nodata: "No data",
    enter_email_or_phone: "Enter email and/or phone number",
  },
  form: {
    accepting_patients: "Accepting patients",
    add_stripe_customer: {
      button: "Create Account",
      could_not_create: "Could not create Stripe Customer",
      siren: "SIREN",
      stripe_account: "Stripe Account",
      successfully_created: "Successfully created Stripe Customer",
      title: "Add Stripe Customer",
    },
    address: "Address",
    adherence_appointment_on_sudden_inactivity: "Check-in call for inactivity",
    assign_new_therapist: "Assign new therapist",
    assign_temporary_therapist: "Substitute therapist",
    available_for_patients: "Available for patients",
    available_to_substitute: "Available to substitute",
    birth: "Date of birth",
    booking_ignore_accepting_patients: "RTM treatment enabled",
    by: "By",
    by_category: "By category",
    care_event: "Care event",
    change_hcp: {
      header: "Change Health Care Provider",
    },
    changed_hcp: {
      header: "Health Care Provider has been changed",
    },
    change_payer: "Change Payer",
    change_physician: "Change Physician",
    clinic: "Clinic",
    comment: "Comment",
    completed_date: "Completed date",
    country: "Country",
    create_health_care_organization: "Create Health Care Organization",
    create_new_health_care_organization: "Create new Health Care Organization",
    create_new_health_care_provider: "Create new Health Care Provider",
    edit_health_care_organization: "Edit Health Care Organization",
    edit_health_care_provider: "Edit Health Care Provider",
    health_care_provider_details: "Health Care Provider Details",
    health_care_provider_invitation_payer: "Payer for patient invitations",
    id: "ID",
    actions: "Actions",
    create_plan_of_care: "Create plan of care",
    custom_welcome_message: "Custom welcome message",
    date: "Date",
    date_of_birth: "Date of birth",
    date_of_physician_signature: "Signed by physician at ",
    body_parts: "Body Parts",
    batch_invited_joint: "Invited Joint",
    gp_address: "GP Address",
    gp_name: "GP Name",
    nhs_number: "NHS Number",
    patient_details: "Patient Details",
    patient_name: "Patient Name",
    pdf_upload: "PDF Upload",
    referral_created: "Referral Created",
    referral_linked_to_existing: "Referral created and linked to existing patient (ID: {{patientId}})",
    referral_invitation_sent: "Referral created. Invitation sent (ID: {{invitationId}})",
    referral_date: "Referral Date",
    referral_details: "Referral Details",
    select_pdf: "Select PDF",
    extracting_pdf_fields: "Extracting PDF fields...",
    site: "Site",
    uk_referral_override: "UK Referral Override",
    uk_referral_batch: "UK Referral Batch Upload",
    pathway_ids: "Pathway ID(s)",
    urgency: "Urgency",
    gp_details_optional: "GP Details (Optional)",
    batch_drop_files: "Drop NHS referral PDFs here",
    batch_drop_hint: "or click to select files",
    batch_processing: "Processing PDFs...",
    batch_progress: "{{processed}} of {{total}} processed",
    batch_extraction_failed: "Extraction Failed",
    batch_file_name: "File",
    batch_summary: "Review & Submit",
    batch_ready_count: "{{count}} Referral ready for submission",
    batch_ready_count_plural: "{{count}} Referrals ready for submission",
    batch_error_count: "{{count}} with errors",
    batch_warning_count: "{{count}} Referral needs review",
    batch_warning_count_plural: "{{count}} Referrals need review",
    batch_validation_issues: "Please review highlighted fields",
    needs_review: "Needs Review",
    batch_submitting: "Submitting {{current}} of {{total}}...",
    batch_complete: "Batch Upload Complete",
    batch_results: "{{submitted}} {{referralWord}} submitted, {{failed}} failed",
    batch_invites_sent: "Invitations sent to new patients only. Existing patients have been linked to their referrals.",
    batch_submitting_button: "Submitting...",
    extracting: "Extracting...",
    ready: "Ready",
    submitted: "Submitted",
    error: "Error",
    status: "Status",
    file: "File",
    date_of_service: "Date of service",
    delete_unclaimed_referral: "Do you want to delete this unclaimed medical referral?",
    doctor_id: "Doctor Id",
    document_uploaded: "Document uploaded",
    drop_in_calls_push: "Drop-in Calls",
    duration_days: "Duration days",
    email: "Email",
    sms: "SMS",
    expires_at: "Expires at",
    feature_flags: "HCP Feature Flags",
    find_patients_in: "Find patients in",
    find_therapists_in: "Find therapists in",
    find_hcps_in: "Find HCPs in",
    find_hcos_in: "Find HCOs in",
    first_name: "First Name",
    functionality_test: "Functionality Test",
    health_care_organization: "Health Care Organization",
    health_care_provider: "Health Care Provider",
    hco_details: "Health Care Organization Details",
    hco_details_short: "Details",
    hco_contact_email: "Contact Email",
    hco_billing_email: "Billing Email",
    hco_address: "Address",
    hco_city: "City",
    hco_zip_code: "Zip Code",
    hco_status: "Status",
    hco_subscription: "Stripe Subscription",
    hco_create_subscription: "Create Subscription",
    hco_update_subscription: "Update Subscription",
    hco_cancel_subscription: "Cancel Subscription",
    hco_create_subscription_confirm_per_seat: "Create a subscription with per seat price {{amount}}?",
    hco_create_subscription_confirm_flat_fee: "Create a subscription with flat fee {{amount}}?",
    hco_create_subscription_confirm_no_price: "No matching Stripe price found for the configured fee amount. Proceed anyway?",
    hco_cancel_subscription_confirm: "Are you sure you want to cancel this subscription? This action cannot be undone.",
    hco_subscription_created_successfully: "Subscription created successfully",
    hco_subscription_updated_successfully: "Subscription updated successfully",
    hco_subscription_cancelled_successfully: "Subscription cancelled successfully",
    hco_stripe_price: "Stripe Price",
    hco_per_seat_subscription_note: "Stripe subscription price will be configured in the next step after creating the HCO.",
    hco_pricing_model_locked_subscription: "Pricing model cannot be changed while a Stripe subscription is active.",
    hco_pricing: "Pricing",
    hco_edit_pricing: "Edit Pricing",
    hco_pricing_updated_successfully: "Pricing updated successfully",
    hco_pricing_subscription_sync_note: "Saving will also update the active Stripe subscription.",
    hco_organization_size_range: "Organization Size",
    hco_platform_fee: "Platform Fee",
    hco_platform_fee_model: "Platform Fee Model",
    hco_platform_fee_cents: "Platform Fee (Cents)",
    hco_platform_fee_bps: "Platform Fee (BPS)",
    hco_platform_fee_percentage: "Platform Fee (%)",
    hco_seats: "Seats",
    hco_country: "Country",
    hco_state: "State",
    hco_stripe_customer_id: "Stripe Customer ID",
    hco_stripe_subscription_id: "Stripe Subscription ID",
    hco_stripe_subscription_status: "Stripe Subscription Status",
    hco_created_successfully: "Health Care Organization created",
    hco_updated_successfully: "Health Care Organization updated",
    hco_earnings: "Estimated Earnings",
    hco_earnings_current_month: "Current Month",
    hco_earnings_last_month: "Last Month",
    hco_earnings_hco_total: "HCO Total",
    hco_earnings_ja_revenue: "JA Revenue",
    hco_earnings_signed_events: "Signed Events",
    hco_earnings_label: "Label",
    hco_earnings_count: "Count",
    hco_earnings_amount: "Earnings",
    hco_earnings_ja_cut: "JA Cut",
    hco_earnings_pending: "pending",
    hco_earnings_completed: "completed",
    hco_earnings_discarded: "discarded",
    health_report: {
      header: "Health Report",
    },
    hep: "HEP",
    home_timezone: "Home timezone",
    profession: "Profession",
    icd_codes: "Diagnosis code",
    in_selfcare: "Is in selfcare",
    initial_pain_rating: {
      header: "Initial Pain Rating",
    },
    invitation_successfully_sent_to: "Invitation successfully sent to",
    invite_billing_admin: "Invite billing admin",
    invite_chenmed_patient: "Invite ChenMed patient",
    invite_partner: "Invite partner",
    invite_physician: "Invite physician",
    invite_therapist: "Invite therapist",
    invited_joint: "Joint",
    ja_consultant: "JA Consultant",
    language: "Language",
    last_name: "Last Name",
    name: "Name",
    new_clinic: "Add new clinic",
    new_record: "New record",
    new_referral_source: "New referral source",
    no_care_events: "No Care Events",
    no_signed_care_events: "No signed care events",
    none: "None",
    npi: "NPI",
    note_type: "Note type",
    option: "Option",
    options: {
      option_1: "1",
      option_2: "2",
      option_3: "3",
    },
    pain_rating: "Pain rating (0-10)",
    patient_first_name: "Patient's first name",
    patient_last_name: "Patient's last name",
    payer: "Payer name (optional)",
    payer_category: "Payer category",
    payer_name: "Payer",
    phone: "Phone",
    phone_calls: "Phone calls",
    phone_number: "Phone Number",
    other_phone_number: "Other",
    physician: "Physician",
    physician_first_name: "Physician's first name",
    physician_last_name: "Physician's last name",
    preferred_name: "Preferred name",
    provider: "Provider",
    provider_first_name: "Provider's first name",
    provider_last_name: "Provider's last name",
    provider_npi: "Provider NPI",
    reason: "Reason",
    repetitions: "Repetitions",
    roles: "Roles",
    therapist_type: "Therapist type",
    treatment_enrollments: "Treatment Enrollments",
    select_document_type_to_upload: "Select document type to upload",
    selfcare: "Self-care",
    show_metrics: "Show metrics",
    signed_at: "Signed at",
    signed_care_events_only: "Signed care events only",
    source: "Source",
    state: "Patient state",
    state_licenses: "State licenses",
    state_zip: "State/Zip",
    stripe_customer: "Stripe Customer",
    success: "Success",
    successfully_changed_hcp_to: "Successfully changed HCP to",
    suggest_adherence_appointment: "Suggest Adherence Appointment",
    type: "Type",
    upload_abn: "Upload ABN document",
    upload_abn_document: "Upload ABN document",
    upload_poc: "Upload Plan of care",
    value: "Value",
    video_calls: "Video calls",
    voice_calls: "Voice calls",
    weekday: "Weekday",
    weekly_patient_assignment_limit: "Weekly patient assignment limit",
    welcome_message_only_extra: "Disable default welcome message",
    which_clinic: "Which clinics does the partner manage?",
    category: "Category",
    slug: "Slug",
    admits_patients: "Admits patients",
    created_at: "Created at",
    rtm: "RTM",
    rtm_enabled: "RTM Enabled",
    hep_enabled: "HEP Enabled",
    web_booking_enabled: "Web Booking Enabled",
    demo_mode: "Demo Mode",
  },
  fr_invoices: {
    label: "FR Invoices",
    month_label: "See invoices for",
    table: {
      care_events: "Total Care Events",
      supplementary: "Supplementary events",
      therapist: "Therapist",
      video_calls: "Video calls",
    },
  },
  insurance: {
    copay: "Copay",
    copay_estimate_cents: "Copay estimate cents",
    could_not_update_insurance: "Could not update insurance",
    could_not_remove_insurance: "Could not remove insurance",
    medicare: "Medicare",
    medicare_amount_used: "Medicare amount used",
    medicare_usage: "Medicare Usage",
    memberid: "Member ID",
    none: "None",
    patient_eligible: "Patient is eligible",
    primary: "Primary Insurance",
    secondary: "Secondary Insurance",
    update_primary_insurance: "Update primary insurance",
    update_secondary_insurance: "Update secondary insurance",
  },
  manage_treatments: {
    activate_button_label: "Activate",
    activate_for: "Activate {{joint}} for {{scope}}?",
    activate_treatment: "Activate",
    activate_treatment_error_message: "Error activating treatment",
    activated_header: "Activated!",
    activation_warning: "Note! This action can not be turned off after activation (it can only be triggered again).",
    all_current_therapists: "All current therapists",
    all_incoming_patients: "All incoming patients",
    all_incoming_therapists: "All incoming therapists",
    cancel_button_label: "Cancel",
    fetch_treatments_error_message: "Error fetching treatments",
    hand: "Hand",
    header: "Manage joints in",
    label: "Manage joints",
    lower_back: "Lower back",
    neck: "Neck",
    shoulder: "Shoulder",
    trigger_treatment: "Trigger",
    trigger_treatment_again: "Trigger again",
  },
  messages: {
    substitute_therapist_change: {
      end: "This patient has been reassigned to you from {therapistName}",
      start: "This patient has been temporarily assigned to you from {therapistName}",
      start_with_end_date:
        "This patient has been temporarily assigned to you from {therapistName} until {assignmentEndDate}",
    },
  },
  none: "None",
  partner_patients: {
    name: "Name",
    treatment_started: "Treatment started",
  },
  partner_referral_table: {
    duration: "Duration",
    referral_issued: "Referral received",
  },
  patient: {
    care_events: "Care Events",
    ce_structure: "CE Structure",
    deleted: "Deleted",
    discharged: "Discharged",
    exemption_card: "Exemption card",
    journey_in_selfcare: {
      false: "False",
      true: "True",
    },
    journey_state: {
      blocked: "Blocked",
      discharged: "Discharged",
      in_custom_course: "In custom course",
      in_first_health_form: "In first health form",
      in_introduction: "In introduction",
      in_selfcare: "In selfcare",
      in_six_week_course: "In six week course",
      in_sustain_course: "In sustain course",
      invited: "Invited",
      new: "New",
      referred_elsewhere: "Referred elsewehere",
      treatment_ended: "Treatment ended",
    },
    medical_records: {
      initial_pain_rating: "Initial pain rating",
    },
    premium_type: "Subscription",
    premium_types: {
      none: "No subscription",
      selfcare: "Self care",
      guided_care: "Guided care",
    },
    pt_on_demand: {
      pt_on_demand: "PT on demand",
      pt_on_demand_enabled: "PT-on-demand enabled",
    },
    remove_item_title: "Are you sure you want to remove {{name}} from patient?",
  },
  patients: {
    account: "Account",
    actions: "Actions",
    activities: "Activities",
    ailment: "Ailment",
    created: "Created",
    document: "Document",
    documents: "Documents",
    payer: "Payer",
    end_treatment_form: {
      close_account: "Close account",
      reasons: {
        other: "Other",
        acquired_tools: "Is appropriate to continue independently",
        ceased_activity: "Non compliant",
        cost: "Cost prohibitive",
        insurance_rejected: "Insurance not accepted",
        not_interested: "Patient not interested",
        not_selfcare: "Patient has been offered the Self-Care program but is not interested ",
        not_suitable: "Treatment not suitable",
        referred_elsewhere: "Referred to another healthcare provider",
        surgery: "Recently underwent or is scheduled for surgery",
        symptom_free: "Patient is symptom free",
        unreachable: "Unable to reach patient ",
        wrong_treatment: "Incorrect painful joint selected by patient in registration",
      },
    },
    ended_by: "Ended by",
    generate_uk_discharge_letter: "Generate UK discharge letter",
    handle: "Handle",
    header_info: {
      most_painful_joint_short: "Joint",
    },
    health: {
      difficulty_values: ["None"],
    },
    health_reports: {
      none: "None",
      questions_content: {
        none: "None",
        rmdq_none: "None of the above is true.",
      },
    },
    payers: {
      name: "Name",
    },
    id: "ID",
    invite_a_patient: "Invite a patient",
    invite_sent: "An invite has been sent!",
    lateral_location: {
      both: "Both",
      left: "Left",
      right: "Right",
      undefined: "undefined",
    },
    medical_records: {
      abn: "ABN",
      health_journal: "Health Journal",
      not_applicable: "N/A",
      personal_number: "Personal identity number",
      plan_of_care: "Plan of care",
      referral: "Referral",
      referral_for: "Referral for",
      social_security_number: "Social security number",
    },
    menu: {
      protocol: "Protocol",
    },
    no_activities: "No activities",
    no_documents: "No documents",
    notes: {
      discharge_visit_dropdown: {
        options: {
          none: "No billable communication",
        },
      },
      fields: {
        discharge_communication_options: {
          none: "No billable communication",
        },
      },
    },
    pain_location: {
      elbow: "Elbow",
      elbow_one: "Elbow",
      elbow_other: "Elbows",
      fall_prevention_one: "Fall prevention",
      foot: "Foot",
      foot_one: "Ankle/Foot",
      foot_other: "Ankles/Feet",
      hand: "Hand",
      hand_one: "Hand/Wrist",
      hand_other: "Hands/Wrists",
      hip: "Hip",
      hip_one: "Hip",
      hip_other: "Hips",
      jaw: "Jaw",
      jaw_one: "Jaw",
      jaw_other: "Jaws",
      knee: "Knee",
      knee_one: "Knee",
      knee_other: "Knees",
      lower_back: "Lower back",
      lower_back_one: "Lower back",
      lower_leg: "Lower leg",
      lower_leg_one: "Lower leg/Achilles",
      lower_leg_other: "Lower legs/Achilles",
      neck: "Neck",
      neck_one: "Neck",
      osteoporosis_one: "Osteoporosis",
      shoulder: "Shoulder",
      shoulder_one: "Shoulder/Shoulder blade",
      shoulder_other: "Shoulders/Shoulder blades",
      spine: "Spine",
      spine_one: "Spine",
      upper_back: "Upper back",
      upper_back_one: "Upper back",
      wrist: "Wrist",
      wrist_one: "Wrist",
      wrist_other: "Wrists",
      chest: "Chest",
    },
    protocol: {
      awaiting_completion: "awaiting completion",
      change_levels: "Change levels",
      completed: "Completed",
      current: "Current",
      delay: "{days} days delay",
      levels_description:
        "Changes will apply to the patient's current exercises.\nSetting the level to zero means that the exercise is removed for the patient.",
      no_activities: "No activities scheduled",
      overdue: "This week has been put on hold until the patient completes the mandatory activities.",
      removed_exercise: "Removed exercise",
      required: "* This activity needs to be completed in order for the next week of the protocol to be enabled.",
    },
    remove_offline_visit_and_billing: "Remove offline visit and billing",
    reopen_account: "Reopen account",
    reopen_treatment: "Reopen treatment",
    revert_treatment_switch: "Revert switch",
    roles: {
      physician: "Physician",
      therapist: "Physical therapist",
    },
    state: "State",
    statuses: {
      active: "Active",
      deleted: "Account Closed",
      end_treatment: "Ending",
      inactive: "Inactive",
      referral_and_authorization: "Ref. & Pre-Auth",
      referral_needed: "Referral needed",
      requires_authorization: "Pre-Auth needed",
    },
    substitute_therapist: "Temporary",
    tool_tip: {
      substitute_therapist: "Substitute therapist",
    },
    treatment: "Current treatment",
    treatment_history: "Treatment history",
    uk_discharge_letter: {
      address: "Address: ",
      contact_at: "Contact at: ",
      contact_link: "support@jointacademy.co.uk",
      date: "Date: ",
      date_of_birth: "Date of birth: ",
      differential_diagnosis: "Differential diagnosis: ",
      discharge_further_action: "Action required",
      discharge_no_further_action: "No action required",
      discharge_note_to_patient: "Discharge note to patient",
      discharge_patient_f2f: "Patient requesting F2F / Patient does not want digital care",
      discharge_self_management: "Self Management",
      discharge_gp_action: "GP Action (Non MSK related/ Cancer/ Neurology)",
      discharge_advanced_physio: "Advanced Physiotherapy Practitioner",
      discharge_physio_f2f: "Physiotherapy Face to Face",
      discharge_other: "Other",
      discharge_urgency: "Discharge urgency",
      discharge_urgency_options: {
        routine: "Routine",
        urgent: "URGENT",
      },
      download: "Download PDF",
      footer: {
        line_1: "Yours sincerely",
        line_2: "{{ therapistName }}, Physiotherapist",
        line_3: "If you require any further information, please do not hesitate to contact us at: ",
        line_4:
          "Your referrer (NHS) and your GP will receive a copy of this document. Please also share this information with any other people, or services involved in supporting you with your health and care needs.",
      },
      generate: "Generate",
      goal_achieved: "Goal achieved.",
      goal_not_achieved: "Goal not achieved.",
      goal_partially_achieved: "Goal partially achieved.",
      goal_free_text: "Patient specific goals: ",
      goal_functionality: "Function goal: ",
      goal_pain: "Pain goal: ",
      goals: "Goals:",
      inspection_v2: "Observation",
      palpation_v2: "Palpation",
      neurology_v2: "Neurology",
      joint_functionality_v2: "Joint function",
      functional_tests_v2: "Functional tests",
      initial_call: "Initial call",
      header: {
        line_1: "Registered offices: 11 Dudhope Terrace,",
        line_2: "Dundee, Scotland,",
        line_3: "DD3, 6TS",
      },
      nhs_number: "NHS number: ",
      management: "Management: ",
      medication: "Medications: ",
      objective: "Objective: ",
      past_medical_history: "Previous medical history: ",
      plan: "Plan: ",
      progression: "Progression: ",
      regarding: "Regarding: ",
      subjective: "Subjective: ",
      red_flags: "Red flags: ",
      table: {
        adherence: "Adherence",
        bmi: "BMI",
        eq5d: "Quality of Life: EQ5D",
        function: "Function: 30 sec sit to stand",
        header: {
          measure: "Measure",
          outcome: "Outcome",
          pre: "Pre- Treatment",
          post: "Post- Treatment",
        },
        healthform_score: {
          fihoa: "Hand function FIHOA",
          hoos: "Hip function HOOS",
          koos: "Knee function KOOS",
          rmdq: "Back function RMDQ",
          npq: "Neck function NPQ",
          spadi: "Shoulder function SPADI",
          unknown: "Unknown",
        },
        initial_eq5d: "Initial EQ5D",
        latest_eq5d: "Latest EQ5D",
        not_applicable: "N/A",
        nrs: "NRS pain (0-10)",
        outcome: {
          improved: "Improved",
          regressed: "Regressed",
          unchanged: "Unchanged",
        },
      },
      telephone: "Telephone: ",
      treatment_programme: "Treatment Programme: ",
      site: "Site",
      show_email_in_pdf: "Show email in PDF",
      pdf_updated: "PDF Updated ✓",
      generate_discharge_letter_to_patient: "Generate discharge letter to patient",
      confirm_replace_discharge_letter:
        "A discharge letter has already been uploaded for this patient. Do you want to replace it with a new version?",
      discharge_letter_updated: "Discharge letter successfully updated!",
      discharge_letter_uploaded: "Discharge letter successfully uploaded!",
      discharge_letter_upload_error: "Failed to upload discharge letter. Please try again.",
      patient_discharge_email_consent: "Patient discharge email consent",
      patient_discharge_letter_last_uploaded: "Patient discharge letter last uploaded",
      view: "View",
      yes: "Yes ✓",
      no: "No",
      yes_option: "Yes",
      no_option: "No",
      gp_address: "GP Address",
    },
    view_all: "View all",
    visible_for_therapist: "Visible for therapist",
    week: "Week",
    weeks: "Weeks",
  },
  payers: {
    payers_in: "Payers in",
    table: {
      header: {
        id: "Id",
        name: "Name",
        code: "Code",
        category: "Category",
      },
      no_payers_found: "No payers could be found",
    },
    save_warn: "Before switching payer make sure no other operation needs to be done",
  },
  protocol: "Protocol",
  provider_group: {
    could_not_update: "Could not update provider group",
    label: "Provider groups",
    none: "None",
    title: "Provider group",
    update: "Update Provider Group",
    updated: "Provider group was successfully updated",
  },
  rcm: {
    bill: "Bill",
    care_event: "Care Event ID",
    cdm: "CDM",
    cdmfull: "Charge Description Matrix",
    claim_successfully_resubmitted: "Claim successfully resubmitted",
    claimid: "Claim ID",
    claims: "Claims",
    claimstitle: "Claims Overview",
    create: "Create",
    error_bill_invoice: "Couldn't bill the invoice",
    error_claim_generation: "Something went wrong when generating a claim!",
    error_create_invoice: "Couldn't create the invoice",
    generate_claim: "Generate Claim",
    generate_success: "Claim submitted!",
    icd: "ICD Code",
    insurancecompany: "Insurance Company",
    invoice_billed: "Billed",
    invoice_created: "Created",
    invoices: "Invoices",
    label: "Label",
    member_id: "Member ID",
    memberid: "Member ID",
    note: "Note",
    open_invoice_details: "Open invoice details",
    patientid: "Patient ID",
    payer: "Payer",
    payerstate: "Payer State",
    physician_id: "Physician id",
    referenceid: "Reference ID",
    resubmit: "Resubmit",
    resubmit_claim: "Resubmit claim",
    sentdate: "Sent Date",
    service: "Date of Service",
    state: "State",
    videocall: "Confirmed Video Call",
  },
  referral: {
    upload_document: "Upload document",
    upload_referral: "Upload referral",
    upload_referral_form: "Referral registration",
    upload_success: "Referral file uploaded for patient with id",
  },
  remove_sub_form: {
    remove_substitute: "Remove substitute therapist",
  },
  reports: {
    close_note: "Close note",
    note: "Note",
    note_does_not_exist: "Note does not exist",
    open_note: "Open note",
  },
  settings: {
    profile_information: {
      time_zone: "Time zone",
      weekly_assignment_limit: "Weekly patient limit:",
    },
  },
  substitute_therapist: "Substitute therapist",
  text_no: "No",
  text_yes: "Yes",
  therapist_profile: {
    feature_toggle_title: "Feature toggle",
    treatment_toggle_title: "Treatment toggle",
    all_joints: "All Joints",
  },
  therapist: {
    change_hcp: {
      button: "Change HCP",
    },
    create_and_change_hcp: {
      button: "Create and change HCP",
    },
    reset_to_default_hcp: {
      button: "Reset to default HCP",
    },
  },
  therapists: {
    resend_invitation: "Resend invitation email",
    resend_invitation_sent: "Invitation sent!",
    resend_invitation_error: "Could not resend invitation",
    last_invitation_sent_at: "Last sent",
    out_of_office: {
      active_until: "active until",
      end: {
        button: "End out of office",
        submit: "Back to work",
        title: "End out of office period",
      },
      start: {
        button: "Register time off",
        submit: "Submit",
        title: "Mark as out of office",
      },
    },
  },
  unclaimed_referral: {
    upload_success: "Referral file uploaded",
  },
  usercourse: {
    exercise_per_day: "Exercises per day:",
    exercises: "Exercises",
    function_test: "Include function test",
    health_form_type: "Questionnaire",
    healthformtype: {
      fall_prevention: "Fall prevention",
      generic: "Generic",
      hand_oa: "Hand OA",
      hip_oa: "Hip OA",
      knee_oa: "Knee OA",
      low_back_pain: "Low back pain",
      neck: "Neck",
      osteoporosis: "Osteoporosis",
      shoulder_pain: "Shoulder",
    },
    lessons: "Lessons",
    levels: "levels",
    parts: "parts",
    templates: {
      standardized: {
        name: {
          achilles_tendinopathy: "Achilles tendinopathy",
          ankle_instability: "Ankle instability",
          fall_prevention: "Fall prevention",
          foot_oa_or_unspecified: "Foot OA/unspecified foot pain",
          general_elbow_pain: "Non-specific elbow pain",
          hallux_valgus: "Hallux valgus",
          hand_oa: "Hand OA",
          hip_oa: "Hip OA",
          hip_pain_unspecific: "Non-specific hip pain",
          knee_instability: "Knee instability",
          knee_oa: "Knee OA",
          lateral_epicondylalgia: "Lateral epicondylalgia (Tennis elbow)",
          low_back_pain: "Non-specific low back pain",
          medial_epicondylalgia: "Medial epicondylalgia (Golfer's elbow)",
          neck: "Non-specific neck pain",
          osteoporosis: "Osteoporosis",
          patellofemoral_pain_syndrome: "Patellofemoral pain syndrome (Runner's knee)",
          plantar_faschiit: "Plantar fasciitis",
          post_op_hip: "Postoperative program for hip replacement",
          post_op_knee: "Postoperative program for knee replacement",
          pre_op_hip: "Preoperative program for hip replacement",
          pre_op_knee: "Preoperative program for knee replacement",
          shoulder_pain: "Subacromial pain syndrome",
          trochanterit: "Greater trochanteric pain syndrome",
          wrist_pain: "Wrist pain",
        },
      },
    },
  },
  referral_tracking: {
    title: "Referral Tracking",
    subtitle: "Track and manage UK patient referrals",
    export_csv: "Export CSV",
    bulk_edit: "Bulk Edit",
    clear_selection: "Clear",
    selected: "selected",
    no_referrals: "No referrals found",
    no_referrals_hint: "Try adjusting your search or filters.",
    search_placeholder: "Search referrals...",
    filters: "Filters",
    clear_all: "Clear all",
    date_range: "Date Range",
    filter_column: "Column",
    filter_value_hint: "Filter value (comma-separated)",
    patient_state_filter: "Patient State",
    status_filter: "Status",
    site_filter: "Site",
    urgency_filter: "Urgency",
    joint_filter: "Joint",
    special_status: "Special Status",
    comments: "Comments",
    no_change: "No change",
    cancel: "Cancel",
    apply: "Apply",
    bulk_edit_hint: "Set status and/or add comments for all selected referrals.",
    bulk_comment_placeholder: "Add a comment to all selected referrals...",
    date_from: "From",
    date_to: "To",
    all: "All",
    set_date: "Set date...",
    add_value: "Add...",
  },
  views: {
    create_content: "Create content",
    health_care_organizations: "HCOS",
    other: "Other",
    patient: "Patient",
    patients: "Patients",
    payers: "Payers",
    rcm: "RCM",
    registry: "Registry",
    reports: "Reports",
    therapist: "Therapist",
    hcps: "HCPs",
    unclaimed_medical_referrals: "Unclaimed medical referrals",
    invitations: "Invitations",
    medications: "Medications",
  },
  uk_reports: {
    title: "UK Reports",
    monthly: "Monthly Reports",
    quarterly: "Quarterly Reports",
    month: "Month",
    quarter: "Quarter",
    mds: "MDS Report",
    sqpr: "SQPR Report",
    crm: "CRM Report",
    downloading: "Downloading...",
    reconciliation: "MDS Reconciliation",
    reconciliation_help:
      "Paste invoice patient IDs to compare against MDS data. Downloads a CSV tagged with MATCHED, INVOICE_ONLY, MDS_ONLY, and SELF_SIGNUP categories.",
    invoice_ids_placeholder: "Paste invoice patient IDs (one per line or comma-separated)",
    reconcile: "Download Reconciliation",
    download_failed: "Failed to download {{type}} report. Please try again.",
    paste_ids_required: "Please paste invoice patient IDs.",
    reconcile_failed: "Failed to run MDS reconciliation. Please try again.",
  },
  invitations: {
    title: "Invitations",
    status_unclaimed: "Unclaimed",
    status_claimed: "Claimed",
    status_all: "All",
    source_affiliate: "Affiliate",
    source_therapist: "Therapist",
    source_all: "All",
    filter_status: "Status",
    filter_source: "Source",
    filter_search: "Search (email, phone, name, therapist, affiliate)",
    column_id: "ID",
    column_name: "Name",
    column_email: "Email",
    column_phone: "Phone",
    column_source: "Source",
    column_sent_at: "Sent",
    column_last_reminder: "Last reminder",
    column_reminders: "Reminders",
    column_status: "Status",
    view_therapist_invitations: "View patient invitations",
    confirm_delete: "Are you sure you want to delete this invitation?",
    delete_error: "Failed to delete invitation",
    delete_success: "Invitation deleted",
    resend_success: "Invitation resent",
    resend_error: "Failed to resend invitation",
    no_invitations: "No invitations found",
  },
  hcp: {
    account: "HCP Account",
    feature_toggle_title: "Feature toggle",
  },
  lesson_editor: {
    editor_tab: "Editor",
    preview_tab: "Preview",
    images_tab: "Images",
    raw_tab: "⚠️ Raw",
    reset_example: "Reset example",
    clear: "Clear",
    identifier: "Identifier: ",
    target_joints: "Target joints: ",
    image_url_copied: "Image URL copied to clipboard\n\n{{url}}",
    part_divider: "Part {{number}}",
  },
  imageGenerator: {
    promptPlaceholder: "Describe changes or refinements...",
    generating: "Generating image...",
    useThisImage: "Use This Image",
    download: "Download",
    clearHistory: "Clear History",
    confirmClearHistory: "Are you sure you want to clear the chat history?",
    uploadReference: "Upload",
    drawReference: "Draw",
    cameraReference: "Camera",
    removeReference: "Remove Reference",
    promptLanguage: "Prompt Language:",
    errorGenerating: "Error generating image",
    sendMessage: "Send",
    addReference: "Add Reference Image",
    useReferenceImage: "Use reference image",
    useExerciseContext: "Use JA Exercise Context",
    lastGeneratedImage: "Last generated image",
    chatImage: "Chat image",
    currentExerciseImage: "Current Exercise Image",
    useAsReference: "Use as reference",
    capturePhoto: "Capture Photo",
    retakePhoto: "Retake Photo",
    downloadImage: "Download Image",
    rotateImage: "Rotate Image",
    clearDrawing: "Clear Drawing",
    downloadDrawing: "Download Drawing",
    emptyStateMessage: "Start by generating your first image",
    referenceImageAlt: "Reference image",
    generatedImageAlt: "Generated preview",
    generatedImageFilename: "generated-image",
    contextPrefix: {
      title: "The name of the exercise is",
      about: "The instructions for the exercise is as follows:",
      equipment: "The equipment used is:",
      position: "The position is:",
      movement: "The movement is:",
    },
  },
  medications: {
    title: "Medications",
    new_medication: "New Medication",
    edit_medication: "Edit Medication",
    create_medication: "Create Medication",
    translations: "Translations",
    variants: "Variants",
    add_variant: "Add Variant",
    variant_number: "Variant {{number}}",
    labels_per_locale: "Labels per locale",
    name: "Name *",
    description: "Description",
    label: "Label",
    default_image: "Default Image",
    upload_image: "Upload Image *",
    replace_image: "Replace Image",
    uploading: "Uploading…",
    save_changes: "Save changes",
    create: "Create",
    deleting: "Deleting…",
    delete: "Delete",
    no_medications: "No medications in catalog. Create one to get started.",
    column_id: "ID",
    column_image: "Image",
    column_name: "Name",
    column_locales: "Locales",
    column_variants: "Variants",
    column_patients: "Patients using",
    column_actions: "Actions",
    confirm_delete_title: "Delete Medication",
    confirm_delete_warning: "Warning: {{count}} patient(s) currently have this medication in their list. Deleting it will remove it from all their lists.",
    confirm_delete_message: "Are you sure you want to delete \"{{name}}\"? This action cannot be undone.",
    locale_image: "Locale Image (optional)",
    upload_locale_image: "Upload locale image",
    replace_locale_image: "Replace locale image",
    remove_locale_image: "Remove locale image",
    using_default_image: "Using default image",
    error_unsupported_file: "Unsupported file type. Please upload a JPEG or PNG image.",
    error_upload_failed: "Failed to upload image.",
    error_translation_required: "At least one translation is required.",
    error_default_image_required: "A default image is required.",
    error_create_failed: "Failed to create medication.",
    error_update_failed: "Failed to update medication.",
    error_delete_failed: "Failed to delete medication.",
  },
};
